import { ColumnDef } from '@tanstack/angular-table';
import { TableDateCellComponent } from '@core/components/table/table-date-cell/table-date-cell.component';
import { TableColorCellComponent } from '@core/components/table/table-color-cell/table-color-cell.component';
import { flexRenderComponent } from '@tanstack/angular-table';
import { TradesHistory } from '../interfaces/trades-history.interface';
import { CostComponent } from '@core/components/cost/cost.component';

export const tradesHistoryTableConfig = (): ColumnDef<TradesHistory>[] => [
  {
    accessorFn: (row) => row.id,
    id: 'ID',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.gameid,
    id: 'gameid',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Game ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.offerid,
    id: 'offerid',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Offer ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.type,
    id: 'type',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Type',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.value,
    id: 'value',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Value',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(CostComponent, {
        inputs: {
          cost: value,
          balanceType: 'skins',
          gap: 4,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.date,
    id: 'date',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Time',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(TableDateCellComponent, {
        inputs: {
          value,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.status,
    id: 'status',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Status',
      };
    },
    cell: (cell) => {
      const statuses = {
        accepted: 'var(--green)',
        finalized: 'var(--green)',
        cancelled: 'var(--red)',
        invalid: 'var(--red)',
        finished: 'var(--green)',
        sent: 'var(--yellow)',
      };

      const status = cell.getValue() as string;
      return flexRenderComponent(TableColorCellComponent, {
        inputs: {
          color: statuses[status as keyof typeof statuses],
          value: status,
        },
      });
    },
    enableSorting: true,
  },
];
